import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { Breakpoints } from '@rd-lib/breakpoints';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { tap } from 'rxjs/operators';
import { OfferTermsAndConditionsDialogComponent } from '../../../offer-ui/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import * as actions from '../actions/offer-terms.actions';

@Injectable()
export class OfferTermsEffects {
  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private dialogService: DialogService,
  ) {}

  showOfferTncsModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.OfferTermsActionTypes.SHOW_OFFER_TERMS),
        tap((action: actions.ShowOfferTerms) => {
          const isMobileViewport = window.innerWidth < Breakpoints.TABLET;
          const screenMode = isMobileViewport ? 'fullscreen' : 'center-md';

          // payload is offer
          this.dialogService.open(OfferTermsAndConditionsDialogComponent, {
            data: {
              content: action.payload.terms,
            },
            id: 'offer-terms-and-conditions-dialog',
            screenMode,
            ariaLabel: this.translateService.instant(
              'offer.terms_and_condition_modal.title',
            ),
          });
        }),
      ),
    { dispatch: false },
  );
}
